"use client";
import React from "react";
import { Box, Container, SxProps, Theme, Typography } from "@mui/material";

interface Hero {
  imageSRC: string;
  head: string;
  localImage?: boolean;
  imageAlt?: string;
  customHeading?: string;
  sx?: SxProps<Theme>;
}

const CommonHero: React.FC<Hero> = ({ imageSRC, head, customHeading, sx }) => {
  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...sx,
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: { xs: "15vh", sm: "40vh" },
            minHeight: { xs: "170px", md: "24rem" },
            borderRadius: "20px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: { xs: "0px 15px", md: "0px 38px" },
            backdropFilter: "blur(3px)",
            WebkitBackdropFilter: "blur(3px)",
            border: "1px solid rgba( 255, 255, 255, 0.18 )",
            background: `linear-gradient(to right, rgba(235, 235, 235, 0.71), transparent), url(${imageSRC})`,
            backgroundPosition: "50% 47%",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box sx={{ flex: 2 }}>
            <Typography
              sx={{
                color: "#060273",
                fontSize: { xs: "14px", sm: 15 },
                textAlign: "start",
                border: "1px solid #060273",
                borderRadius: "20px",
                width: "fit-content",
                padding: "2px 8px",
              }}
            >
              Travel better
            </Typography>
            <Typography
              variant="h2"
              component={"h1"}
              mb={0.5}
              width={{ md: "100%" }}
              sx={{
                color: "#060273",
                fontWeight: "bold",
                fontSize: {
                  xs: "2rem",
                  sm: "2.6rem",
                  md: "2.8rem",
                  lg: "3rem",
                },
                textAlign: "start",
              }}
            >
              {head}
            </Typography>

            <Typography
              sx={{
                color: "#060273",
                fontSize: {
                  xs: "14px",
                  sm: 20,
                },
                width: "100%",
                textAlign: "start",
              }}
            >
              {customHeading ?? "Get inspired, Chat with our experts"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default CommonHero;
